import { useState, useEffect } from "react";
import orionAPI from "../config/orionAPI";

const useProfitRanking = () => {
  const [profitRanking, setProfitRanking] = useState([]);
  const [loadingProfitRanking, setLoadingProfitRanking] = useState(true);
  const [error, setError] = useState(null);

  const fetchProfitRanking = async () => {
    setLoadingProfitRanking(true);
    setError(null);
    try {
      const response = await orionAPI.get("/api/profit-ranking");
      setProfitRanking(response.data || []);
    } catch (error) {
      console.error(error);
      setError(
        error.response?.data?.error || "Falha ao buscar ranking de lucros",
      );
      setProfitRanking([]);
    } finally {
      setLoadingProfitRanking(false);
    }
  };

  useEffect(() => {
    fetchProfitRanking();
  }, []);

  return {
    profitRanking,
    loadingProfitRanking,
    error,
    refetch: fetchProfitRanking,
  };
};

export default useProfitRanking;
